/*************************************************/
/* COOKIES                                       */
/*************************************************/
import Recaptcha from "./recaptcha";

export function NewsletterSignup() {
    const formElementSelector = '#newsletterSignupForm';
    const recaptchaFieldElementSelector = '#RecaptchaToken';
    const recaptchaActionName = 'newsletterSignup';
    const successMessageFieldSelector = '.newsletter-signup-form__success';
    const errorMessageFieldSelector = '.newsletter-signup-form__error';

    const init = function () {

        const newsletterSignupForm = document.querySelector(formElementSelector);
        if (newsletterSignupForm) {
            newsletterSignupForm.addEventListener('submit', e => {
                e.preventDefault();

                const successMessage = document.querySelector(successMessageFieldSelector);
                const errorMessage = document.querySelector(errorMessageFieldSelector);

                successMessage.style.display = 'none';
                errorMessage.style.display = 'none';

                const recaptchField = newsletterSignupForm.querySelector(recaptchaFieldElementSelector);
                if (recaptchField) {
                    Recaptcha.GetToken(recaptchaActionName, (token) => {
                        recaptchField.value = token;

                        fetch(e.target.action, {
                            method: 'POST',
                            body: new FormData(e.target)
                        }).then(data => {
                            if (data.status == 200) {
                                successMessage.style.display = 'block';
                            } else {
                                errorMessage.style.display = 'block';
                            }
                        })
                    });
                }
            })
        }
    };

    init();
}